import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";  
import { API_URL } from "../../constants/API_URL"; 
import { DersProgramiError } from "../../types/ErrorModals/DersProgramiError";
import { DersProgramiResponseModal } from "../../types/modals";
import { DersProgramiRequestModal } from "../../types/RequestModals/DersProgramiRequestModal";
import { OgretmenDersProgramiRequestModal } from "../../types/RequestModals/OgretmenDersProgramiRequestModal";

export const getDersProgrami = async (request: DersProgramiRequestModal): Promise<DersProgramiResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<DersProgramiResponseModal[]>>(
      `${API_URL}/api/DersProgrami/getDersProgrami`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Ders programı listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as DersProgramiError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as DersProgramiError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as DersProgramiError;
    }

    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as DersProgramiError;
  }
};

export const getOgretmenDersProgrami = async (request: OgretmenDersProgramiRequestModal): Promise<DersProgramiResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<DersProgramiResponseModal[]>>(
      `${API_URL}/api/DersProgrami/getOgretmenDersProgrami`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Ders programı listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as DersProgramiError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as DersProgramiError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as DersProgramiError;
    }

    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as DersProgramiError;
  }
};